import axios from 'axios'
import configuration from './config'


const apiService = axios.create({
    baseURL: configuration.api.baseUrl
})

export default apiService